<template>
    <div class="create-company-page page" style="max-width: 600px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title">Create Company</h4>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <company/>
        </div>
    </div>
</template>

<script>
    import Company from "@/components/main/Company";

    export default {
        components: {
            Company
        }
    }
</script>

<style scoped>

</style>
